import { atom } from "jotai/vanilla";

/**
 * Make the main layout hide the sidebar etc.
 * Useful for testing.
 */
export const showOnlyContentAtom = atom<boolean>(false);
